import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';

const config = {
  apiKey: 'AIzaSyCtBD2GuK81YMG6gmGm32iVmnNMsFNbc9c',
  authDomain: 'ava-product.firebaseapp.com',
  databaseURL: 'https://ava-product.firebaseio.com',
  projectId: 'ava-product',
  storageBucket: 'ava-product.appspot.com',
  messagingSenderId: '47114113593',
  appId: '1:47114113593:web:15e4a50ec9794553b333e8',
  measurementId: 'G-DD8J9370TW',
};

const app = firebase.initializeApp(config);
export const analytics = firebase.analytics();

export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const facebookProvider = new firebase.auth.FacebookAuthProvider();
export const appleProvider = new firebase.auth.OAuthProvider('apple.com');
export const authInstance = firebase.auth();

let firestore = undefined;
export const getFirestore = async () => {
  await import(/* webpackChunkName: "firebase" */ 'firebase/firestore');
  if (!firestore) firestore = firebase.firestore();
  return firestore;
};
export default firebase;

export const restName = 'firebase-mobile';
